jQuery(document).ready(function($) {
  $('.home-slider').fadeIn();

  $('.home-slider').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    centerMode: true,
    cssEase: 'linear',
    variableWidth: true,
    variableHeight: true,
    responsive: [
      {
        breakpoint: 975,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  });
});
